import React from "react";
import { Table, Spinner, Badge, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { FaEye, FaDownload, FaEllipsisV } from "react-icons/fa";

const InvoiceTable = ({
  loading,
  invoices,
  page,
  paginate,
  actionDropdowns,
  setActionDropdowns,
  setSelectedInvoice,
  setViewModal,
  handleExportInvoice
}) => {
  const getStatusBadge = (status) => {
    const statusColors = {
      paid: 'success',
      pending: 'warning',
      overdue: 'danger',
      cancelled: 'secondary'
    };
    return <Badge color={statusColors[status] || 'secondary'}>{status}</Badge>;
  };

  return (
    <Table hover responsive>
      <thead>
        <tr>
          <th>SL. No.</th>
          <th>Invoice #</th>
          <th>Issue Date</th>
          <th>Due Date</th>
          <th>Billed To</th>
          <th>Type</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr>
            <td colSpan="9" className="text-center">
              <Spinner />
            </td>
          </tr>
        ) : invoices.length === 0 ? (
          <tr>
            <td colSpan="9" className="text-center">No invoices found</td>
          </tr>
        ) : (
          invoices.map((invoice, index) => (
            <tr key={invoice.id}>
              <th scope="row">{index + 1 + page * paginate}</th>
              <td>{invoice.invoice_number}</td>
              <td>{new Date(invoice.issue_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
              <td>{new Date(invoice.due_date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
              <td>{invoice.billed_to_name}</td>
              <td>
                <span className={`badge ${invoice.invoice_type === 'booking' ? 'bg-info' : invoice.invoice_type === 'service' ? 'bg-success' : 'bg-warning'}`}>
                  {invoice.invoice_type}
                </span>
              </td>
              <td>₹{parseFloat(invoice.total_amount).toLocaleString()}</td>
              <td>{getStatusBadge(invoice.status.toLowerCase())}</td>
              <td>
                <Dropdown
                  isOpen={actionDropdowns[invoice.id] || false}
                  toggle={() => setActionDropdowns(prev => ({ ...prev, [invoice.id]: !prev[invoice.id] }))}
                >
                  <DropdownToggle className="btn btn-sm btn-outline-secondary">
                    <FaEllipsisV style={{ color: 'white' }} />
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem 
                      onClick={() => {
                        setSelectedInvoice(invoice);
                        setViewModal(true);
                      }}
                    >
                      <FaEye className="me-2" /> View Details
                    </DropdownItem>
                    <DropdownItem onClick={() => handleExportInvoice(invoice.id)}>
                      <FaDownload className="me-2" /> Download PDF
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default InvoiceTable;